// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"7641853a","214":"2888098a","459":"88a9c574","528":"08018463","779":"a7bf9f88","781":"df8e4e6d","865":"5d64d704","899":"21004c3b"}[chunkId] + ".chunk.css";
};